module.exports = __webpack_public_path__ + "img/mz-logo.e273e059.png";